<template>
    <div class="page">
        <div class="section-box">
            <div class="section-1">
                <div class="left">
                    <div class="img-box">
                        <div>
                            <img :src="mix_user_avatar" alt />
                        </div>
                        <div class="name">
                            {{ my_info.nickname }}
                        </div>
                    </div>
                </div>
                <div class="right">
                    <!-- <div class="text-1">{{ mix_user_name }}</div>
                    <div class="text-2">
                        <span>2131</span>
                    </div> -->
                    <div class="textBox">{{ mix_user_phone }}</div>
                    <div class="textBox2">
                        <img src="../../assets/img/mine/vipIcon.png" class="vipIcon" alt="" />
                        <div class="vipTitle">{{ my_info.levelTitle }}</div>
                    </div>
                </div>
            </div>

            <div class="section-2">
                <!-- <div class="list">
                    <div class="item" @click="$router.push('/order-list?order_status=1')">
                        <div class="val">
                            <span>{{ user_index.order_num_1 || '0' }}</span>
                        </div>
                        <div class="label">待付款</div>
                    </div>
                    <div class="item" @click="$router.push('/order-list?order_status=2')">
                        <div class="val">
                            <span>{{ user_index.order_num_2 || '0' }}</span>
                        </div>
                        <div class="label">待发货</div>
                    </div>
                    <div class="item" @click="$router.push('/order-list?order_status=3')">
                        <div class="val">
                            <span>{{ user_index.order_num_3 || '0' }}</span>
                        </div>
                        <div class="label">待收货</div>
                    </div>
                    <div class="item" @click="$router.push('/order-list?order_status=4')">
                        <div class="val">
                            <span>{{ user_index.order_num_4 || '0' }}</span>
                        </div>
                        <div class="label">待评价</div>
                    </div>
                </div> -->

                <div class="list">
                    <div class="item" @click="$router.push('/order-list')">
                        <div class="val">
                            <span>{{ my_info.orderNum || '0' }}</span>
                        </div>
                        <div class="label">标准鼓订单</div>
                    </div>
                    <div class="item" @click="$router.push('/order-list2')">
                        <div class="val">
                            <span>{{ my_info.customizedOrderNum || '0' }}</span>
                        </div>
                        <div class="label">定制鼓订单</div>
                    </div>
                    <div class="item" @click="$router.push('/favorite-list')">
                        <div class="val">
                            <span>{{ my_info.shoucangNum || '0' }}</span>
                        </div>
                        <div class="label">我的收藏</div>
                    </div>

                    <!-- 未认证 -->
                    <div class="item" @click="goAuth(1)" v-if="my_info.renzheng == 0">
                        <img src="../../assets/img/mine/yesIcon.png" class="yesIcon" alt="" />
                        <div class="label">立即认证享优惠</div>
                    </div>

                    <!-- 认证中 -->
                    <div class="item" v-if="my_info.renzheng == 1" @click="goAuth(2)">
                        <img src="../../assets/img/mine/yesIcon.png" class="yesIcon" alt="" />
                        <div class="label"><span style="color: #ff4d00">认证中</span>&nbsp&nbsp<span>查看</span></div>
                    </div>

                    <!-- 认证被驳回 -->
                    <div class="item" v-if="my_info.renzheng == -1" @click="goAuth(3)">
                        <img src="../../assets/img/mine/yesIcon.png" class="yesIcon" alt="" />
                        <div class="label"><span style="color: #ff4d00">被驳回</span>&nbsp&nbsp<span>修改</span></div>
                    </div>

                    <!-- 通过认证 -->
                    <div class="item" @click="goAuth(4)" v-if="my_info.renzheng == 2">
                        <img src="../../assets/img/mine/yesIcon.png" class="yesIcon" alt="" />
                        <div class="label">个人信息</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="section-order">
      <div class="section-title">
        <div class="label">最近订单</div>
        <router-link to="/order-list" class="action">
          <span>全部订单</span>
          <img src="@/static/my-index/more.png" alt="" />
        </router-link>
      </div>

      <div class="order-box">
        <div class="empty-info" v-if="!list_order.length">
          <div class="empty-img">
            <img src="@/static/common/empty-img.png" alt="" />
          </div>
          <div class="empty-text">您还没有订单，赶快去逛逛吧！</div>
          <router-link to="/product-cates" class="empty-action">
            进入产品中心
          </router-link>
        </div>
        <div class="order-info" v-else>
          <orderList :list="list_order" @confirm="emitConfirm" />
        </div>
      </div>
    </div>

    <div class="suggest-goods">
      <div class="section-title">
        <div class="label">我们向您推荐</div>
        <div class="action" @click="changeSugges">
          <span>换一组</span>
          <img src="@/static/my-index/refresh.png" alt="" />
        </div>
      </div>

      <div class="list-wrap">
        <productList :list="list_goods" />
      </div>
    </div> -->

        <!-- 认证弹窗 -->
        <div class="authWinBox" v-show="authWin != 0">
            <!-- 认证信息填写 -->
            <div class="authWin" v-show="authWin == 1">
                <div class="winTop">
                    <div class="winTitle">企业认证</div>
                    <div class="closeBtnBox" @click="closeAuthWin">
                        <img src="../../assets/img/mine/closeIcon.png" class="closeIcon" alt="" />
                    </div>
                </div>
                <div class="winFlexBigBox">
                    <div class="winItem">
                        <div class="winItemTitle">公司名称：</div>
                        <div class="winItemInput">
                            <input type="text" :disabled="authWinType == 2" v-model="company" placeholder="请输入公司名称" class="winInput" />
                        </div>
                    </div>
                    <div class="winItem">
                        <div class="winItemTitle">联系人：</div>
                        <div class="winItemInput">
                            <input type="text" :disabled="authWinType == 2" v-model="contactPeople" placeholder="请输入联系人姓名" class="winInput" />
                        </div>
                    </div>
                    <div class="winItem">
                        <div class="winItemTitle">法定代表人：</div>
                        <div class="winItemInput">
                            <input type="text" :disabled="authWinType == 2" v-model="legalName" placeholder="请输入法定代表人姓名" class="winInput" />
                        </div>
                    </div>
                    <div class="winItem">
                        <div class="winItemTitle">手机号：</div>
                        <div class="winItemInput">
                            <input type="text" :disabled="authWinType == 2" v-model="legalPhone" placeholder="请输入联系人手机号" class="winInput" />
                        </div>
                    </div>
                    <div class="winItem">
                        <div class="winItemTitle">注册资金：</div>
                        <div class="winItemInput">
                            <input type="text" :disabled="authWinType == 2" v-model="registerMoney" placeholder="请输入注册资金" class="winInput" />
                        </div>
                    </div>
                    <div class="winItem">
                        <div class="winItemTitle">地址：</div>
                        <div class="winItemInput">
                            <input type="text" :disabled="authWinType == 2" v-model="companyAddress" placeholder="请输入公司地址" class="winInput" />
                        </div>
                    </div>
                    <div class="winItem">
                        <div class="winItemTitle">纳税人识别码：</div>
                        <div class="winItemInput">
                            <input
                                type="text"
                                :disabled="authWinType == 2"
                                v-model="taxpayerCode"
                                placeholder="请输入纳税人识别码"
                                class="winInput"
                            />
                        </div>
                    </div>
                    <div class="winItem">
                        <div class="winItemTitle">邮箱：</div>
                        <div class="winItemInput">
                            <input type="text" :disabled="authWinType == 2" v-model="companyEmail" placeholder="请输入公司邮箱" class="winInput" />
                        </div>
                    </div>
                    <div class="winItem">
                        <div class="winItemTitle">营业执照：</div>
                        <!-- 添加图片 -->
                        <div class="winUploadImg" @click="uploadImgBtn" v-if="!businessImage">
                            <input type="file" accept="image/*" @change="imgInputChange" class="fileInput" ref="fileInput" />
                            <img src="../../assets/img/mine/addIcon.png" class="addIcon" />
                            <div class="uploadFileText">添加图片</div>
                        </div>
                        <!-- 已经有图片 -->
                        <div class="previewImgBox" v-else>
                            <el-image
                                class="previewImg"
                                :src="businessImage"
                                :preview-src-list="[businessImage]"
                                :initial-index="0"
                                fit="contain"
                            ></el-image>
                            <div class="delImg" @click="delImg" v-if="authWinType == 1">
                                <img src="../../assets/img/mine/delImg.png" class="delImgIcon" alt="" />
                            </div>
                        </div>
                    </div>

                    <div class="winBtnFlexBox" v-if="authWinType == 1">
                        <div class="winBottomBtn" @click="winSub">提交</div>
                        <div class="winBottomBtn2" @click="closeAuthWin">取消</div>
                    </div>
                </div>
            </div>
            <!-- 认证信息提交成功 -->
            <div class="authWin2" v-show="authWin == 2">
                <div class="winTop">
                    <div class="winTitle">提交成功</div>
                    <div class="closeBtnBox" @click="closeAuthWin">
                        <img src="../../assets/img/mine/closeIcon.png" class="closeIcon" alt="" />
                    </div>
                </div>
                <img src="@/assets/img/mine/successIcon.png" class="successIcon" alt="" />
                <div class="authWin2Title">认证申请提交成功！</div>
                <div class="authWin2Title2">请耐心等待管理员审核</div>
                <div class="authWin2FlexBtnBox">
                    <div class="authWin2Btn" @click="queryAuthMsg">查看认证信息</div>
                    <div class="authWin2Btn2" @click="closeAuthWin">继续浏览</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import productList from '@/components/product/productList.vue'
// import cusUploader from "@/components/uploader/cusUploader.vue"; //上传
import orderList from '@/components/order/orderList.vue' //
import { mapState } from 'vuex'

export default {
    name: 'servicePage',
    components: {
        productList,
        orderList,
        // cusUploader,
    },
    data() {
        return {
            pagination: {
                page: '1',
                pageNum: '8',
            },
            count: 0,

            my_info: {},
            user_index: {}, //用户首页数据
            list_order: [],
            list_goods: [],

            uploadImg: '',
            youhui_code: '',
            youhui_msg: '',

            authWin: 0, // 认证弹窗：0.关闭，1.认证，2.已提交认证
            authWinType: 1, // 认证弹窗状态：1.可编辑，2.仅查看
            company: '',
            contactPeople: '',
            legalName: '',
            legalPhone: '',
            registerMoney: '',
            companyAddress: '',
            taxpayerCode: '',
            companyEmail: '',
            businessImage: '',
        }
    },
    computed: {
        // ...mapState([""]),
    },
    created() {
        this.setView()
    },
    methods: {
        usersRenzhengAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'users_renzheng',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        uploadImgBtn() {
            this.$refs['fileInput'].click()
        },
        async imgInputChange() {
            const file = this.$refs['fileInput'].files[0]
            const fileName = file.name // 文件名字
            const index = file.name.lastIndexOf('.')
            const ext = file.name.substr(index + 1) // 文件类型
            const size = file.size / 1024 / 1024 // 文件大小（单位：MB）
            this.$load.open()
            let res = await this.$uploadFile(file)
            this.$load.close()
            if (res) {
                this.businessImage = res
            } else {
                alert('上传失败')
            }

            this.$refs['fileInput'].value = ''
        },
        delImg() {
            this.businessImage = ''
        },
        closeAuthWin() {
            this.authWin = 0
        },
        // 查看认证信息
        async queryAuthMsg() {
            let { company, contactPeople, legalName, legalPhone, registerMoney, companyAddress, taxpayerCode, companyEmail, businessImage } =
                this.my_info
            this.company = company
            this.contactPeople = contactPeople
            this.legalName = legalName
            this.legalPhone = legalPhone
            this.registerMoney = registerMoney
            this.companyAddress = companyAddress
            this.taxpayerCode = taxpayerCode
            this.companyEmail = companyEmail
            this.businessImage = businessImage
            this.authWinType = 2
            this.authWin = 1
        },
        goAuth(type) {
            if (type == 1) {
                // 未认证
                this.company = ''
                this.contactPeople = ''
                this.legalName = ''
                this.legalPhone = ''
                this.registerMoney = ''
                this.companyAddress = ''
                this.taxpayerCode = ''
                this.companyEmail = ''
                this.businessImage = ''
                this.authWinType = 1
                this.authWin = 1
            } else if (type == 2) {
                // 认证中
                let { company, contactPeople, legalName, legalPhone, registerMoney, companyAddress, taxpayerCode, companyEmail, businessImage } =
                    this.my_info
                this.company = company
                this.contactPeople = contactPeople
                this.legalName = legalName
                this.legalPhone = legalPhone
                this.registerMoney = registerMoney
                this.companyAddress = companyAddress
                this.taxpayerCode = taxpayerCode
                this.companyEmail = companyEmail
                this.businessImage = businessImage
                this.authWinType = 2
                this.authWin = 1
            } else if (type == 3) {
                // 认证被驳回
                let { company, contactPeople, legalName, legalPhone, registerMoney, companyAddress, taxpayerCode, companyEmail, businessImage } =
                    this.my_info
                this.company = company
                this.contactPeople = contactPeople
                this.legalName = legalName
                this.legalPhone = legalPhone
                this.registerMoney = registerMoney
                this.companyAddress = companyAddress
                this.taxpayerCode = taxpayerCode
                this.companyEmail = companyEmail
                this.businessImage = businessImage
                this.authWinType = 1
                this.authWin = 1
            } else if (type == 4) {
                // 通过认证
                this.$router.push({
                    path: '/my-info',
                })
            }
        },
        async winSub() {
            function checkPhone(tel) {
                if (!tel) {
                    return false
                }
                let regu = /^1[3-9][0-9]{9}$/

                if (regu.test(tel)) {
                    return true
                } else {
                    return false
                }
            }

            function checkEmail(val) {
                if (!val) {
                    return false
                }
                let regu = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

                if (regu.test(val)) {
                    return true
                } else {
                    return false
                }
            }
            if (!this.company) {
                alertErr('请输入公司名称')
                return
            }
            if (!this.contactPeople) {
                alertErr('请输入联系人姓名')
                return
            }
            if (!this.legalName) {
                alertErr('请输入法定代表人')
                return
            }
            if (!checkPhone(this.legalPhone)) {
                alertErr('请输入有效的手机号')
                return
            }
            if (!this.registerMoney) {
                alertErr('请输入注册资金')
                return
            }
            if (!this.companyAddress) {
                alertErr('请输入地址')
                return
            }
            if (!this.taxpayerCode) {
                alertErr('请输入纳税人识别码')
                return
            }
            if (!checkEmail(this.companyEmail)) {
                alertErr('请输入有效的邮箱')
                return
            }
            if (!this.businessImage) {
                alertErr('请上传营业执照')
                return
            }

            let obj = {
                company: this.company,
                contactPeople: this.contactPeople,
                legalName: this.legalName,
                legalPhone: this.legalPhone,
                registerMoney: this.registerMoney,
                companyAddress: this.companyAddress,
                taxpayerCode: this.taxpayerCode,
                companyEmail: this.companyEmail,
                businessImage: this.businessImage,
            }
            this.$load.open()
            let res = await this.usersRenzhengAjax(obj)
            await this.query_user()
            await this.$load.close()
            if (res && res.code == 200) {
                this.authWin = 2
            }
        },
        emitConfirm() {
            this.query_order()
        },
        setView() {
            this.query_user()
            this.query_userIndex()
            this.query_order()
            this.query_goods()
        },
        query_user() {
            return new Promise((resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'users_userInfo',
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        this.my_info = res.data
                    }
                    resolve()
                })
            })
        },

        //用户主页数据
        query_userIndex() {
            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'users_index',
                },
            }).then((res) => {
                let { code, data } = res
                if (res.code == 200) {
                    this.user_index = res.data
                }
            })
        },

        //订单查询
        query_order() {
            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'orders_lists',
                    page: 1,
                    pageNum: 2,
                    scene: 0,
                },
            }).then((res) => {
                let { code, data } = res
                if (code == 200) {
                    this.list_order = data.list
                }
            })
        },

        //商品信息
        query_goods() {
            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'product_plist',
                    ifShowSku: 1,
                    ...this.pagination,
                },
            }).then((res) => {
                let { code, data, count } = res
                if (code == 200) {
                    let { list, count, pages } = data
                    this.list_goods = list
                    this.count = count
                }
            })
        },

        changeSugges() {
            if (this.count > this.pagination.pageNum * this.pagination.page) {
                this.pagination.page++
                this.query_goods()
            } else {
                alertErr('没有更多了...')
            }
        },
    },
}
</script>

<style scoped lang="less">
/deep/ .box-wrap .list .item:nth-child(4n) {
    margin-right: 0;
}

/deep/ .box-wrap .list .item:nth-child(5n) {
    margin-right: 10px;
}

/deep/ .box-wrap .list .item {
    margin-top: 10px;
}

/deep/ .box-wrap .list .item:nth-child(-n + 4) {
    margin-top: 10px;
}

.section-box {
    .flex();
}

.authWinBox {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;

    .winBtnFlexBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 60px;

        .winBottomBtn {
            width: 104px;
            height: 40px;
            background: #ff4d00;
            font-size: 14px;
            line-height: 14px;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 20px;
            cursor: pointer;
        }

        .winBottomBtn2 {
            width: 104px;
            height: 40px;
            border: 1px solid #ff4d00;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            line-height: 14px;
            color: #ff4d00;
            cursor: pointer;
        }
    }

    .authWin {
        width: 1200px;
        background: #ffffff;
        box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.16);
        border-radius: 4px 4px 4px 4px;
        padding-bottom: 50px;

        .winTop {
            width: 100%;
            height: 60px;
            background: #f7f7f7;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 24px;
            margin-bottom: 32px;

            .winTitle {
                font-size: 18px;
                line-height: 18px;
                color: #333333;
            }

            .closeBtnBox {
                width: 26px;
                height: 26px;
                cursor: pointer;

                .closeIcon {
                    width: 26px;
                    height: 26px;
                }
            }
        }

        .winFlexBigBox {
            width: calc(100% - 82px - 82px);
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;

            .winItem {
                width: 26vw;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                margin-bottom: 22px;

                .winItemTitle {
                    width: 110px;
                    font-size: 14px;
                    line-height: 14px;
                    color: #999999;
                    text-align: end;
                }

                .winItemInput {
                    width: 400px;
                    height: 50px;
                    background: #ffffff;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #eeeeee;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 15px;

                    .winInput {
                        width: 100%;
                        height: 100%;
                        font-size: 16px;
                        line-height: 16px;
                        color: #555555;
                    }

                    .winInput::placeholder {
                        color: #d7d7d7;
                    }
                }

                .winUploadImg {
                    margin-left: 10px;
                    width: 104px;
                    height: 104px;
                    background: rgba(0, 0, 0, 0.04);
                    border-radius: 2px 2px 2px 2px;
                    border: 1px solid rgba(0, 0, 0, 0.15);
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    position: relative;
                    top: 20px;

                    .fileInput {
                        position: fixed;
                        top: -100000px;
                        left: -100000px;
                        opacity: 0;
                    }

                    .addIcon {
                        width: 32px;
                        display: block;
                        margin-bottom: 10px;
                    }

                    .uploadFileText {
                        font-size: 14px;
                        line-height: 14px;
                        color: #878787;
                    }
                }

                .previewImgBox {
                    width: 104px;
                    height: 104px;
                    display: block;
                    position: relative;
                    top: 20px;
                    background: rgba(0, 0, 0, 0.04);

                    .previewImg {
                        width: 104px;
                        height: 104px;
                        display: block;
                    }

                    .delImg {
                        width: 16px;
                        height: 16px;
                        position: absolute;
                        top: -8px;
                        right: -8px;
                        cursor: pointer;
                        z-index: 9;

                        .delImgIcon {
                            width: 16px;
                            height: 16px;
                        }
                    }
                }
            }
        }
    }

    .authWin2 {
        width: 580px;
        height: 362px;
        background: #ffffff;
        box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.16);
        border-radius: 4px 4px 4px 4px;

        .winTop {
            width: 100%;
            height: 60px;
            background: #f7f7f7;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 24px;
            margin-bottom: 26px;

            .winTitle {
                font-size: 18px;
                line-height: 18px;
                color: #333333;
            }

            .closeBtnBox {
                width: 26px;
                height: 26px;
                cursor: pointer;

                .closeIcon {
                    width: 26px;
                    height: 26px;
                }
            }
        }

        .successIcon {
            display: block;
            width: 70px;
            margin: 0 auto 0 auto;
        }

        .authWin2Title {
            font-size: 24px;
            line-height: 24px;
            color: #000000;
            width: 100%;
            text-align: center;
            margin-top: 25px;
            margin-bottom: 25px;
        }

        .authWin2Title2 {
            width: 100%;
            text-align: center;
            font-size: 14px;
            line-height: 14px;
            color: #333333;
            margin-top: 25px;
            margin-bottom: 35px;
        }

        .authWin2FlexBtnBox {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .authWin2Btn {
                width: 128px;
                height: 40px;
                background: #ff4d00;
                border-radius: 0px 0px 0px 0px;
                font-weight: 500;
                font-size: 14px;
                color: #ffffff;
                line-height: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 25px;
                cursor: pointer;
            }

            .authWin2Btn2 {
                width: 128px;
                height: 40px;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #000000;
                font-size: 14px;
                line-height: 14px;
                color: #000000;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }
        }
    }
}

.section-1 {
    .flex-center();
    position: relative;
    background: #ffffff url('../../assets/img/mine/mineColorBg.png') no-repeat;
    background-size: 100% 100%;
    padding: 0 15px;
    width: 256px;
    height: 210px;

    .left {
        height: calc(100% - 48px);

        .img-box {
            img {
                width: 80px;
                height: 80px;
                border-radius: 50%;
                object-fit: cover;
                display: block;
                margin: 0 auto;
            }
        }

        .name {
            width: 100%;
            text-align: center;
            margin-top: 10px;
            font-size: 14px;
            font-weight: 500;
            color: #ffffff;
        }
    }

    .right {
        .flex-between();
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 48px;
        background: #ffffff;
        text-align: left;
        padding: 0 25px;
        border: 1px solid #ff4d00;
        border-radius: 0 0 11px 11px;

        .textBox {
            font-size: 14px;
            line-height: 14px;
            color: #333333;
        }

        .textBox2 {
            display: flex;
            align-items: center;
            justify-content: center;

            .vipIcon {
                width: 24px;
                display: block;
                margin-right: 4px;
            }

            .vipTitle {
                font-size: 14px;
                line-height: 14px;
                color: #fc5a00;
            }
        }
    }
}

.section-2 {
    flex: 1;

    .list {
        .flex-between();
        height: 185px;
        background: #ffffff;
        border: 1px solid #eee9e4;

        .item {
            text-align: center;
            width: 25%;
            padding: 10px 0;
            border-right: 1px solid #d5d8de;
            // margin-left: 40px;
            // margin-right: 40px;
            font-size: 16px;
            cursor: pointer;

            .yesIcon {
                width: 34px;
                height: 34px;
                display: block;
                margin: 0 auto;
            }

            &:last-child {
                border-right: none;
            }

            .label {
                margin-top: 20px;
                font-size: 16px;
                font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
                font-weight: normal;
                color: #333333;
            }

            .val {
                span {
                    font-size: 32px;
                    font-weight: normal;
                    color: #ff4d00;
                }
            }
        }
    }
}

.page {
    padding-bottom: 70px;
}

.section-title {
    border-bottom: 1px solid #dedede;
    .flex-between();
    height: 56px;
    padding: 0 32px;

    .label {
        font-size: 18px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }

    .action {
        .flex();
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #4ca5e4;
        cursor: pointer;

        img {
            width: 14px;
            margin-left: 10px;
        }
    }
}

.section-order {
    margin: 25px 0;
    background: #fff;

    .order-box {
        .empty-info {
            text-align: center;
            padding: 40px 0;

            // border-top: 1px solid #dedede;
            .empty-img {
                text-align: center;

                img {
                    width: 190px;
                }
            }

            .empty-text {
                margin-top: 10px;
                margin-bottom: 20px;
                font-size: 14px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                color: #999999;
            }

            .empty-action {
                font-size: 14px;
                color: #4ca5e4;
            }
        }
    }

    .order-info {
        padding: 24px 32px;
    }
}

.suggest-goods {
    background: #fff;

    .list-wrap {
        padding: 40px 30px;
    }

    /deep/ .product-list {
        .product-item {
            // margin-right: 23px;

            &:nth-child(4n) {
                // margin-right: 0;
            }

            &:nth-child(5) {
                // margin-top: 50px;
            }
        }
    }
}
</style>

<style scoped lang="less" src="@/assets/h5css/user/my-index.less"></style>
